import { render, staticRenderFns } from "./Actos.vue?vue&type=template&id=e0a91500&scoped=true"
import script from "./Actos.vue?vue&type=script&lang=js"
export * from "./Actos.vue?vue&type=script&lang=js"
import style0 from "./Actos.vue?vue&type=style&index=0&id=e0a91500&prod&lang=scss"
import style1 from "./Actos.vue?vue&type=style&index=1&id=e0a91500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a91500",
  null
  
)

export default component.exports